import { WebP } from '/src/components/WebP';
import { RenderTriggerText } from '/src/features/goals/utils';
import { GOAL_TRIGGERS_METADATA } from '/src/features/goals/constants';

export function GoalTriggerList({ triggers }) {
  return (
    <div className="w-[387px] text-left leading-none px-5 pt-3.75 pb-[26px]">
      <div className="font-bold text-xs pb-3.75">Triggers</div>
      <ul className="w-full max-h-[476px] overflow-x-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-cadet-blue-500 scrollbar-thumb-rounded">
        {triggers.map((trigger) => {
          return (
            <li className="border-b-5 border-black last:border-none" key={trigger.id}>
              <div className="bg-mako-500 rounded-md p-2.5 flex h-[60px]">
                <div className="h-10 w-10 rounded bg-white bg-opacity-10 flex items-center justify-center">
                  <WebP
                    className="w-[25px]"
                    webp={GOAL_TRIGGERS_METADATA[trigger.type.toUpperCase()]?.webp ?? GOAL_TRIGGERS_METADATA.OTHER.webp}
                    fallback={
                      GOAL_TRIGGERS_METADATA[
                        GOAL_TRIGGERS_METADATA[trigger.type.toUpperCase()]?.png ?? GOAL_TRIGGERS_METADATA.OTHER.png
                      ]
                    }
                    width="25"
                    alt="trigger type"
                  />
                </div>
                <div className="flex items-center flex-1 overflow-hidden pl-3 pr-5">
                  <div className="flex flex-col overflow-hidden text-left">
                    <RenderTriggerText trigger={trigger} />
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
